import { render, staticRenderFns } from "./ConfigurationView.vue?vue&type=template&id=5c9effcf&scoped=true"
import script from "./ConfigurationView.vue?vue&type=script&lang=js"
export * from "./ConfigurationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9effcf",
  null
  
)

export default component.exports